import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Send } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Switch } from "./ui/switch";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function WhatsAppPrefs({ role = "restaurant" }) {
  const { user, refresh } = useAuth();
  const [status, setStatus] = useState({ enabled: false, sandbox: false });
  const [phone, setPhone] = useState(user?.whatsapp_phone || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/whatsapp/status").then(({ data }) => setStatus(data)).catch(() => {}); }, []);
  useEffect(() => { setPhone(user?.whatsapp_phone || ""); }, [user?.whatsapp_phone]);
  const save = async (patch, msg = "Preferenze WhatsApp salvate") => {
    setBusy(true);
    try { await api.patch("/auth/me", patch); await refresh(); toast.success(msg); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const test = async () => {
    setBusy(true);
    try { await api.post("/whatsapp/test"); toast.success("Messaggio di prova inviato su WhatsApp"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="ga-card p-5" data-testid="whatsapp-prefs">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><MessageCircle className="w-3.5 h-3.5 text-emerald-600" /> Avvisi WhatsApp</div>
          <div className="mt-1 text-sm text-slate-600">{role === "supplier" ? "Ricevi su WhatsApp quando la tua offerta viene superata e quando un ordine viene pagato." : "Ricevi su WhatsApp le nuove offerte dei fornitori e le consegne da confermare."}</div>
          {!status.enabled && <div className="mt-1 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1 inline-block" data-testid="whatsapp-not-configured">Servizio in attivazione: puoi già salvare il numero, gli avvisi partiranno appena attivo.</div>}
          <div className="mt-1 text-[11px] text-slate-500" data-testid="whatsapp-antistress-note">Niente stress: max 5 messaggi al giorno, nessun avviso promozionale tra le 22 e le 8, solo eventi che richiedono un'azione. Disattivabile in qualsiasi momento.</div>
          {status.enabled && status.sandbox && <div className="mt-1 text-xs text-amber-800" data-testid="whatsapp-sandbox-notice">Modalità test Twilio: invia prima "join" al numero sandbox per ricevere i messaggi.</div>}
        </div>
        <Switch checked={!!user?.whatsapp_opt_in} disabled={busy} onCheckedChange={(v) => save({ whatsapp_opt_in: v, ...(v && phone !== user?.whatsapp_phone ? { whatsapp_phone: phone } : {}) }, v ? "Avvisi WhatsApp attivati" : "Avvisi WhatsApp disattivati")} data-testid="whatsapp-switch" />
      </div>
      <div className="mt-3 flex flex-col sm:flex-row gap-2">
        <Input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="+39 3XX XXXXXXX" className="sm:max-w-xs" data-testid="whatsapp-phone-input" />
        <Button type="button" variant="outline" disabled={busy || phone === (user?.whatsapp_phone || "")} onClick={() => save({ whatsapp_phone: phone }, "Numero salvato")} className="rounded-full" data-testid="whatsapp-save-button">Salva numero</Button>
        <Button type="button" variant="outline" disabled={busy || !status.enabled || !user?.whatsapp_phone} onClick={test} className="rounded-full" data-testid="whatsapp-test-button"><Send className="w-3.5 h-3.5 mr-1.5" /> Invia prova</Button>
      </div>
    </div>
  );
}
